import * as RadixAccordion from '@radix-ui/react-accordion';
import { getThemeAnimation } from 'front-commons/ds';
import styled from 'styled-components';

export const Trigger = styled(RadixAccordion.Trigger)`
	width: 100%;

	${getThemeAnimation().chevron.rotate('i', 'data-state', { initial: 'closed', final: 'open' }, '-180').Parent}
`;

export const SummaryRoot = styled(RadixAccordion.Root)`
	${getThemeAnimation().accordion.openClose().Root}
`;

export const SummaryContent = styled(RadixAccordion.Content)`
	${getThemeAnimation().accordion.openClose().Content}
`;
